// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__KkyHv","token_input":"style_token_input__xSFJJ","token_select":"style_token_select__30uev","error_message":"style_error_message__1Fj9q"};